export const fixInlineImages = (body) => {
    //if src="https://p.pform.net and has data source url with mapi url, then use sourceurl instead
    const capturingRegex = /src="(?<badlink>https:\/\/p.pform.net\/([^"]+))" data-sourceurl="(?<goodlink>https:\/\/mapi([^"]+))"/g;
    body = body.replaceAll(capturingRegex, 'src="$<goodlink>" data-sourceurl="$<goodlink>"');

    //handle draft case when both src and data-sourceurl are pform links. in this case source-url is correct one
    const capturingRegexDraft = /src="(?<badlink>https:\/\/p.pform.net\/([^"]+))" data-sourceurl="(?<goodlink>https:\/\/p.pform.net([^"]+))"/g;
    body = body.replaceAll(capturingRegexDraft, 'src="$<goodlink>" data-sourceurl="$<goodlink>"');

    return body;
};
